


















































import {
  computed, defineComponent, Ref, ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import { useFormat, useRouter } from '@ideavivat/vivat-2';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import uploadCashFlowPreview from '@/gql/cashflow/uploadCashFlowPreview.gql';
import uploadCashFlowCsv from '@/gql/cashflow/uploadCashFlowCsv.gql';

import cashFlowPreview from '@/table/cashFlow/cashFlowPreview';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';

const CommonDropzoneWithCashFlowUpload = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  setup() {
    const { router } = useRouter();
    const toCurrency = (str: string | number) => useFormat.number(str).currency();
    const { translateDistanceType } = useDeliveryAreaCode();

    const deleteCashFlowModal = ref(null);
    const previewModal = ref(null);
    const uploadCashFlowCsvPreviewMutation = useMutation(uploadCashFlowPreview, {
      context: {
        hasUpload: true,
      },
    });

    const previewCsv: Ref<any> = ref([]);
    uploadCashFlowCsvPreviewMutation.onDone((data: any) => {
      previewCsv.value = data?.data.uploadCashFlowCsvPreview;
      (previewModal.value as any).open();
    });

    const uploadCashFlowCsvMutation = useMutation(uploadCashFlowCsv, () => ({
      variables: {
        cashFlows: previewCsv.value.map((cashFlow: any) => ({
          ...cashFlow,
          /* eslint-disable */
          payment_account_id: parseInt(cashFlow.paymentAccount?.id) || undefined,
          delivery_note_id: parseInt(cashFlow.deliveryNote?.id) || undefined,
          driver_id: parseInt(cashFlow.driver?.id) || undefined,
          vehicle_id: parseInt(cashFlow.vehicle?.id) || undefined,
          /* eslint-enable */
          paymentAccount: undefined,
          deliveryNote: undefined,
          vehicle: undefined,
          driver: undefined,
          __typename: undefined,
        })),
      },
      refetchQueries: ['getCashFlows'],
    }));

    uploadCashFlowCsvMutation.onDone(() => {
      (previewModal.value as any).close();
      previewCsv.value = [];
      router.push({ name: 'CashFlowList' });
    });

    const amount = computed(() => {
      let result = 0;
      previewCsv.value.forEach((record: any) => {
        result += record.amount;
      });
      return result;
    });

    return {
      toCurrency,
      translateDistanceType,

      cashFlowPreview,
      previewCsv,

      uploadCashFlowCsvPreviewMutation,
      uploadCashFlowCsvMutation,

      previewModal,
      deleteCashFlowModal,

      amount,
    };
  },
});

export default CommonDropzoneWithCashFlowUpload;
